module.exports = __webpack_public_path__ + "static/media/pdf_download.f82ae627.jpg";